import { toAppUrl } from '../constants/siteDomains';

interface AuthEntryButtonsProps {
  variant?: 'header' | 'hero';
  className?: string;
  showTrialHint?: boolean;
  onNavigate?: () => void;
}

const AuthEntryButtons: React.FC<AuthEntryButtonsProps> = ({
  variant = 'header',
  className = '',
  showTrialHint = false,
  onNavigate,
}) => {
  const loginUrl = toAppUrl('/login');
  const signupUrl = toAppUrl('/login?cadastro=1');

  if (variant === 'hero') {
    return (
      <div className={className}>
        {showTrialHint && (
          <p className="mb-4 text-base font-medium text-[#496566] sm:text-lg">
            Experimente gratuitamente: cadastre o seu e-mail e use agora
          </p>
        )}
        <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <a
            href={loginUrl}
            onClick={onNavigate}
            className="inline-flex items-center justify-center rounded-full border-2 border-[#3A5859] px-8 py-4 text-base font-semibold text-[#3A5859] transition hover:bg-[#3A5859] hover:text-white"
          >
            Entrar
          </a>
          <a
            href={signupUrl}
            onClick={onNavigate}
            className="inline-flex items-center justify-center rounded-full bg-[#A56096] px-8 py-4 text-base font-semibold text-white shadow-lg transition hover:-translate-y-0.5 hover:bg-[#945586]"
          >
            Cadastrar
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 sm:gap-3 ${className}`}>
      <a
        href={loginUrl}
        onClick={onNavigate}
        className="rounded-full border border-[#3A5859]/25 px-4 py-2 text-sm font-medium text-[#3A5859] transition-colors hover:border-[#3A5859] hover:bg-white"
      >
        Entrar
      </a>
      <a
        href={signupUrl}
        onClick={onNavigate}
        className="rounded-full bg-[#A56096] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#945586]"
      >
        Cadastrar
      </a>
    </div>
  );
};

export default AuthEntryButtons;
